import { useHistory } from "react-router-dom";
import { HISTORY_KEY } from "src/constants/UrlConstants";
import { MAX_HISTORY_ENTRIES, ROUTE_PATHS } from "src/utils/constants";
import { createCookie, getCookie } from "src/utils/cookies";

const useSmartGoBack = () => {
  const history = useHistory();

  const saveHistory = (paths) => {
    createCookie(HISTORY_KEY, encodeURIComponent(JSON.stringify(paths)), null);
  };

  const navigateTo = (path) => {
    history.push(path, { replace: true });
  };

  const smartGoBack = () => {
    let historyPath = Array.isArray(getCookie(HISTORY_KEY))
      ? getCookie(HISTORY_KEY)
      : [];

    const currentPath = history.location.pathname + history.location.search;

    if (historyPath.length === 0) {
      navigateTo(ROUTE_PATHS.PRODUCTS);
      return;
    }

    if (historyPath.length > MAX_HISTORY_ENTRIES) {
      historyPath = historyPath.slice(-MAX_HISTORY_ENTRIES);
      saveHistory(historyPath);
    }

    const lastPath = historyPath[historyPath.length - 1];

    historyPath.pop();

    if (lastPath === currentPath) {
      if (historyPath.length >= 1) {
        const previous = historyPath.pop();
        saveHistory(historyPath);
        navigateTo(previous);
      } else {
        navigateTo(ROUTE_PATHS.PRODUCTS);
      }
    } else {
      saveHistory(historyPath);
      navigateTo(lastPath);
    }
  };

  return smartGoBack;
};

export default useSmartGoBack;
